<template>
   <b-field
           :label="label"
           :type="error? 'is-danger': ''"
           :message="error">
       <b-field class="file">
           <b-upload @input="inputFile">
               <a class="button is-primary">
                   <b-icon icon="upload"></b-icon>
                   <span>{{ holder }}</span>
               </a>
           </b-upload>
           <span class="file-name" v-if="file">
            {{ file.name }}
        </span>
       </b-field>
   </b-field>
</template>

<script>
    export default {
        name: "FormUpload",
        data() {
            return {
                file: null
            }
        },
        props: {
            name: String,
            label: {
                type: String,
                default: 'Cargar Archivo'
            },
            holder: {
                type: String,
                default: 'Click para cargar'
            },
            value: {},
            error: {},
            accept: String,
        },
        created() {
            if (this.value) {
                this.file = {
                    name: this.value
                }
            }
        },
        methods: {
            inputFile(file) {
                this.$emit('input', file);
                this.file = file;
            },
        }
    }
</script>

<style scoped>

</style>